import { ReactElement, useEffect, useState } from 'react';
import { IMeetingModalProps } from '.';
import QRCode from 'react-qr-code';
import WhereToScan from '@assets/images/where-scan.png';
import { BIG_MEETS } from '@config/constant';

export const MeetingQrModal = (props: IMeetingModalProps): ReactElement => {
	const { dataObject } = props;
	const isBigMeetingType = (meetingType: string): boolean => {
		const type = meetingType?.toLowerCase();
		return BIG_MEETS.includes(type);
	};

	const [qrValue, setQrValue] = useState<string>(() => {
		if (!dataObject?.sfid) return '';

		return isBigMeetingType(dataObject.meeting_type_c ?? '') ? dataObject.sfid : `${dataObject.sfid}_${Date.now()}`;
	});

	useEffect(() => {
		if (dataObject?.meeting_type_c && isBigMeetingType(dataObject?.meeting_type_c)) {
			setQrValue(dataObject?.sfid);
			return;
		}
		if (!isBigMeetingType(dataObject?.meeting_type_c ?? '')) {
			setQrValue(`${dataObject?.sfid}_${Date.now()}`);

			const interval = setInterval(() => {
				setQrValue(`${dataObject?.sfid}_${Date.now()}`);
			}, 5000);

			return (): void => clearInterval(interval);
		}
	}, [dataObject?.sfid, dataObject?.meeting_type_c]);

	return (
		<div className="about-pop-content">
			<div className="top-content">
				<div className="qr-code-image">
					{dataObject?.sfid && <QRCode value={qrValue} size={200} style={{ height: '200px' }} />}
				</div>

				<span className="h3 fcc-title">{dataObject?.name}</span>

				<p className="date-time">{dataObject?.startdate}</p>

				<div className="divider"></div>
			</div>

			<div className="bottom-content">
				<span className="qs-scan">whare to scan?</span>

				<div className="whare-to-scan">
					<img src={WhereToScan} alt="whare to scan" title="whare to scan" height="210" width="190" />
				</div>
			</div>
		</div>
	);
};
